/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formpurpose_Startdate_Label_Notsure3Inputs */

const ja_contact_formpurpose_startdate_label_notsure3 = /** @type {(inputs: Contact_Formpurpose_Startdate_Label_Notsure3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未定 / わからない`)
};

const en_contact_formpurpose_startdate_label_notsure3 = /** @type {(inputs: Contact_Formpurpose_Startdate_Label_Notsure3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure`)
};

/**
* | output |
* | --- |
* | "Not sure" |
*
* @param {Contact_Formpurpose_Startdate_Label_Notsure3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formpurpose_startdate_label_notsure3 = /** @type {((inputs?: Contact_Formpurpose_Startdate_Label_Notsure3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formpurpose_Startdate_Label_Notsure3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formpurpose_startdate_label_notsure3(inputs)
	return en_contact_formpurpose_startdate_label_notsure3(inputs)
});
export { contact_formpurpose_startdate_label_notsure3 as "contact_formPurpose_startDate_label_notSure" }